export const defaults = {
 0: "Charge SafeCase to 50%",
 1: "Charge SafeCase to 50%",
 2: "Run Compliance Check",
 3: "Run Compliance Check",
 4: "Exit Secure Space and Run Compliance Check",
 5: "Run Compliance or Contact IT",
 6: "",
 7: "Turn Off Cellular Before Entering Secure Space",
 8: "Turn Off Cellular",
 9: "Run Compliance Check",
 10: "Insert Correct/Linked Phone",
 11: "Run Compliance Check"
};
